import React from "react";
import MUICircularProgress from "@mui/material/CircularProgress";
import styles from "./circularProgress.module.scss";
const DIAMETER = {
    small: 16,
    medium: 40,
    large: "7rem",
};
const THICKNESS = {
    small: 5,
    medium: 0.6,
    large: 1.75,
};
const CircularProgress = ({ size = "medium", className, }) => (React.createElement("div", { className: styles.root },
    React.createElement(MUICircularProgress, { className: className, size: DIAMETER[size], thickness: THICKNESS[size], color: "secondary", title: "Loading" })));
export default CircularProgress;
//# sourceMappingURL=CircularProgress.js.map